/**
 * https://developers.google.com/maps/documentation/javascript/tutorial#api_key
    https://developers.google.com/maps/faq#usagelimits 
    (consider enrolling for automated billing, when we go over or purchasing a business license from https://code.google.com/apis/console/#project:445422974445 )

 */
define('controllers/mapsearch',['require'],function (require) {
    //require('fadegallery'); only used for hotel gallery...so this doesn't seem to need it
	function initPage() {
		var destinations = ServerData.feData.destinations;
		var hotels = ServerData.feData.hotels;
		var geocoder,
			map,
			chkShowHotels,
			infowindow = new google.maps.InfoWindow(),
			mapStyles = [
			{
				"elementType": "geometry.fill",
				"stylers": [
				{ "color": "#fefdfa" }
				]
			}, {
				"featureType": "water",
				"stylers": [
				{ "color": "#bfdaf9" },
				{ "lightness": 18 }
				]
			}, {
				"featureType": "road.highway",
				"elementType": "geometry",
				"stylers": [
				{ "visibility": "on" },
				{ "weight": 0.4 },
				{ "color": "#ffd5b5" }
				]
			}, {
				"featureType": "administrative.country",
				"elementType": "labels"
			}, {
				"featureType": "administrative.country",
				"elementType": "labels.text",
				"stylers": [
				{ "visibility": "off" }
				]
			}, {
				"featureType": "administrative.province",
				"elementType": "labels",
				"stylers": [
				{ "visibility": "off" }
				]
			}, {
				"featureType": "administrative.country",
				"elementType": "geometry",
				"stylers": [
				{ "visibility": "on" },
				{ "color": "#f3f3f3" }
				]
			}, {
				"featureType": "road.local",
				"stylers": [
				{ "color": "#808080" },
				{ "visibility": "simplified" },
				{ "lightness": 86 }
				]
			}, {
				"featureType": "road.arterial",
				"stylers": [
				{ "visibility": "on" },
				{ "lightness": 37 }
				]
			}, {
				"featureType": "administrative.province",
				"elementType": "geometry",
				"stylers": [
				{ "visibility": "on" },
				{ "lightness": 73 }
				]
			}
		];

		function setZoomChangedHandler() {
			removeZoomChangedHandler();

			google.maps.event.addDomListener(map, "zoom_changed", function () {
				console.log("Current Zoom: {0}".format(map.zoom));
				var show = map.zoom >= 4;// 10;
				toggleMarkers(hotels, show);
				toggleMarkers(destinations, !show);
			});
		}
		function removeZoomChangedHandler() {
			google.maps.event.clearListeners(map, 'zoom_changed');
		}

		function plotMarkers(locations) {
			if (locations instanceof Array) {
				for (var i = locations.length - 1; i > -1; i--) {
					var location = locations[i],
						point = getPoint(location);

					plotLocation(location, point);
				}

				if (locations.length == 1) {
					map.zoom = 8;
					map.center = point;
				}
			}
		}
		function getPoint(location) {
			return new google.maps.LatLng(location.lat, location.lon);
		}

		function plotLocation(location, point) {
			var marker = AddPointToMap(point, location.type);
			location.marker = marker;
			google.maps.event.addDomListener(marker, "click", function (event) {
			    showInfoWindow.call(this, location, event);
			    window.gaTrack('destinations', 'map', location.type + '_click_' + location.name + (location.id == null ? '' : ': ' + location.id, 1));
			});
		}

		function AddPointToMap(point, markerType) {
			return new google.maps.Marker({
				map: map,
				position: point,
				icon: markerConfig[markerType].mapIcon,
				title: markerType
			});
		}

		function showInfoWindow(location, event) {
			var typeConfig = markerConfig[location.type],
				anchorURL = typeConfig.WindowAnchorPath.format(location.id || (escape(location.name))),
				imagePath = typeConfig.imagePathTemplate.format(location.image),
				contentTemplate = '<a style="font-weight:bold;" href="{0}">{1}</a><br /><a href="{0}"><img style="width:300px;height:200px;" src="{2}" alt="" /></a>',
				content = contentTemplate.format(anchorURL, location.name, imagePath);

			infowindow.setPosition(event.latLng);
			infowindow.setContent(content);
			infowindow.open(map, this);
			map.panTo(event.latLng);
		}

		var codedMarker = undefined;
		function codeAddress() {
			var address = $("#address").val();
			if (address.length > 0) {
				geocoder.geocode({ 'address': address }, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						var firstResult = results[0].geometry.location;
						map.setCenter(firstResult);
						map.setZoom(6);

						if (codedMarker) {
							codedMarker.setMap(null);
						}
						codedMarker = new google.maps.Marker({
							map: map,
							position: firstResult,
							zIndex: 10
						});
					} else {
						console.log("Geocode was not successful for the following reason: " + status);
					}
				});
				window.gaTrack('destinations', 'map', 'search:' + address, 1);
			}
		}

		var markerConfig = {
			destination: {
				imagePathTemplate: ServerData.StaticContentUrl + "images/destinationimages/{0}",
				WindowAnchorPath: "/Member/PlanAVacation/SearchResults.aspx?region={0}",
				mapIcon: ServerData.StaticContentUrl + "images/pin-shadow.png"
			},
			hotel: {
				imagePathTemplate: ServerData.StaticContentUrl + "images/hotelphotos/search/{0}.jpg",
				WindowAnchorPath: "/Member/PlanAVacation/HotelDetails/Default.aspx?hid={0}",
				mapIcon: ServerData.StaticContentUrl + "images/destinationimages/quicksearch/hotel_icon.png"
			}
		};

		function toggleMarkers(markers, show) {
			if (markers != null) {
				var exampleMarker = markers[0],
					plotted = exampleMarker.marker;

				if (!plotted) {
					plotMarkers(markers);
				}

				if (exampleMarker.marker.visible != show) { //only run, if not already set to desired visibility
					for (var i = 0; i < markers.length; i++) {
						markers[i].marker.setVisible(show);
					}

					//set toggle checkbox
					var showingHotels = (exampleMarker.type == "hotel" && show) || (exampleMarker.type == "destination" && !show);
				    chkShowHotels.prop('checked', showingHotels);
				}
			}
		}

		$(function () {
			function initialize() {
				geocoder = new google.maps.Geocoder();
				var latlng = new google.maps.LatLng(36, -40),
					mapOptions = {
						zoom: 3,
						center: latlng,
						mapTypeId: google.maps.MapTypeId.ROADMAP,
						styles: mapStyles
					};

				map = new google.maps.Map(document.getElementById("map_canvas"), mapOptions);
				google.maps.event.addDomListener(map, "click", function () {
					infowindow.close();
				});

				setZoomChangedHandler();
			}

			$("#btnSearch").on("click", function (e) {
				e.preventDefault();
				codeAddress();
			});

			chkShowHotels = $("#chkShowHotels");
			chkShowHotels.on("change", function () {
				var $this = $(this),
					showHotels = $this.is(":checked");

				showHotels ? removeZoomChangedHandler() : setZoomChangedHandler();

				toggleMarkers(hotels, showHotels);
				toggleMarkers(destinations, !showHotels);
				window.gaTrack('destinations', 'map', 'Show Hotels Checkbox', showHotels ? 1:0);
			});

			initialize();
			plotMarkers(destinations);
			codeAddress();
			
			var point = ServerData.feData.point;
			if (point != null) {
				var singlePoint = getPoint(point);
				AddPointToMap(singlePoint, 'hotel');
				map.zoom = 8; 
				map.center = singlePoint;
			}
			
			 $("#hidden_link").fancybox({
                maxWidth: 350,
                maxHeight: 700,
                fitToView: false,
                autoSize: true,
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none'
            }).trigger('click');
			
			$("#address").focus();
		});
	};

    //return function() {
    //	require(['https://maps.google.com/maps/api/js?sensor=false&key=AIzaSyCsSZVOaoUrsxLLYvmT-_nnoot198jg2hA'], initPage);
    //};
	return initPage;
});
